<template>
  <detailed-view-container
    questionnaireTitle="Medication Adherence Report Scale (MARS-5)"
    :questionnaire="questionnaire"
  >
    <template v-slot:questionnnairePanel>
      <MARSQuestionnairePanels :questionnaire="questionnaire" />
    </template>
  </detailed-view-container>
</template>

<script>
const components = {
  MARSQuestionnairePanels: () =>
    import(
      "@/components/views/dashboard/members/id/partial/questionnaires/components/MARSQuestionnairePanels.vue"
    ),
  DetailedViewContainer: () =>
    import(
      "@/components/views/dashboard/members/id/partial/questionnaires/DetailedViewContainer.vue"
    ),
};

export default {
  name: "MARS",

  props: {
    questionnaire: {
      type: Object,
      default: () => {},
    },
  },

  components,
};
</script>